import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import {
    Button,
    Card,
    CardBody,
    Col,
    FormFeedback,
    FormGroup,
    Input,
    Label,
    Row,
} from "reactstrap"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { dateFormat } from "pages/Common"
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from '@fullcalendar/list';
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";


const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        return {
            ...styles,
            border: "1px solid #ced4da",
            minHeight: "35px",
            padding: "3px 10px",
            fontSize: "12px",
            backgroundColor: isDisabled ? "#e9ecef" : "#fff",
            color: isDisabled ? "#6c757d" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            pointerEvents: isDisabled ? "none" : "auto",  // Important for full disabling
            opacity: isDisabled ? 0.6 : 1,
        };
    },
}

function AttendanceMonthlyReport() {
    document.title = `Attendance Report | Raja Rani Couture`
    let { pathname } = useLocation()
    const calendarRef = useRef(null);
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [userFilter, setUserFilter] = useState(0)
    const [users, setUsers] = useState([])
    const [date, setDate] = useState('')
    const [events, setEvents] = useState([])
    const [screenLoad, setScreenLoad] = useState(false)
    const [totalHours, setTotalHours] = useState('0:00')
    const [totalOverTimeHours, setTotalOverTimeHours] = useState('0:00')

    useEffect(() => {
        getApi('Attendance/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])

    useEffect(() => {
        if (userFilter && userFilter !== 0 && calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            const currentStart = calendarApi.view.currentStart;
            const displayedYear = currentStart.getFullYear();
            const displayedMonth = currentStart.getMonth() + 1;
            const firstDayOfDisplayedMonth = `${displayedYear}-${String(displayedMonth).padStart(2, '0')}-01`;

            fetchEvents(firstDayOfDisplayedMonth);
        }
    }, [userFilter]);

    const fetchEvents = (date) => {
        setDate(date);
        setScreenLoad(true);
        postApi("Attendance/monthly-report", {
            AttendanceUserId: (JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") ? parseInt(userFilter) : JSON.parse(localStorage?.getItem("authUser")).AttendanceUserId,
            Date: date,
        }).then(({ data, status }) => {
            if (status === 200) {
                setTotalHours(data?.TotalHours || '0:00')
                setTotalOverTimeHours(data?.TotalOverTimeHours || '0:00')
                // setEvents(
                //     data?.MonthlyReportData?.map(item => {
                //         return {
                //             title: `Working hrs - ${item.TotalHours}`,
                //             start: item.Date,
                //             textColor: '#ffffff'
                //         }
                //     })
                // );

                const eventsArray = data?.MonthlyReportData?.flatMap(item => [
                    {
                        title: `Working Hrs - ${item.TotalHours}`,
                        start: item.Date,
                        textColor: "#ffffff",
                        type: "working",
                        sortIndex: 1
                    },
                    {
                        title: `OT Hrs - ${item.OverTime || "0:00"}`,
                        start: item.Date,
                        textColor: "#000000",
                        type: "ot",
                        sortIndex: 2
                    }
                ]);
                eventsArray.sort((a, b) => a.sortIndex - b.sortIndex);
                setEvents(eventsArray);

            } else {
                toast.error(data, { style: { fontSize: "15px" } });
            }
            setScreenLoad(false);
        });
    };
    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].title}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                />
                <Card>
                    <CardBody>
                        <Row>
                            {(JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") &&
                                <Col className="col-3 mb-3">
                                    <Input
                                        type="select"
                                        id="validationCustom01"
                                        className="form-control"
                                        name="taskType"
                                        bsSize="sm"
                                        onChange={e => {
                                            setUserFilter(e.target.value)
                                        }}
                                        value={userFilter}
                                    >
                                        <option value={0}>Select User</option>
                                        {users.map((item, index) => (
                                            <option key={index} value={item.Key}>{item.Value}</option>
                                        ))}
                                    </Input>
                                </Col>
                            }

                            <Col style={{ display: "flex", justifyContent: "center", alignContent: "center", alignItems: "center" }} md={(JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") ? 5 : 8}>
                                {/* FullCalendar Custom Toolbar */}
                                <div className="d-flex gap-2 align-items-center">

                                    <div className="gap-1 d-flex">
                                        <button title="Previous Month" className="btn btn-primary btn-sm"
                                            onClick={() => calendarRef.current.getApi().prev()}>
                                            <i className="mdi mdi-chevron-left"></i>
                                        </button>
                                        <button title="Next Month" className="btn btn-primary btn-sm"
                                            onClick={() => calendarRef.current.getApi().next()}>
                                            <i className="mdi mdi-chevron-right"></i>
                                        </button>
                                    </div>
                                    <button className="btn btn-primary btn-sm"
                                        onClick={() => calendarRef.current.getApi().today()}>
                                        Today
                                    </button>

                                    {/* Calendar Month Title */}
                                    <div style={{ fontSize: "16px", fontWeight: "600", marginLeft: "10px" }}>
                                        {calendarRef.current?.getApi().view.title}
                                    </div>

                                </div>
                            </Col>

                            <Col md={4} className="text-end">
                                <div style={{ display: "flex", justifyContent: "end", gap: "12px" }}>
                                    <div style={{ fontSize: "16px", fontWeight: "500", marginTop: "5px" }}>
                                        Total Working Hrs: <span style={{ color: "green" }}>{totalHours}</span>
                                    </div>
                                    <div style={{ fontSize: "16px", fontWeight: "500", marginTop: "5px" }}>
                                        Total OT Hrs: <span style={{ color: "green" }}>{totalOverTimeHours}</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col className="col-12">
                                <FullCalendar
                                    height="auto"
                                    contentHeight="auto"
                                    aspectRatio={2}
                                    ref={calendarRef}
                                    plugins={[
                                        BootstrapTheme,
                                        dayGridPlugin,
                                        listPlugin,
                                        interactionPlugin,
                                    ]}
                                    handleWindowResize={true}
                                    themeSystem="bootstrap"
                                    headerToolbar={false}
                                    // headerToolbar={{
                                    //     left: "prev,next today",
                                    //     center: "title",
                                    //     right: "",
                                    // }}
                                    events={events}
                                    eventOrder={['sortIndex']}
                                    datesSet={(info) => {
                                        const displayedDate = info.view.currentStart;
                                        const displayedYear = displayedDate.getFullYear();
                                        const displayedMonth = displayedDate.getMonth() + 1;
                                        const firstDayOfDisplayedMonth = `${displayedYear}-${String(displayedMonth).padStart(2, '0')}-01`;
                                        fetchEvents(firstDayOfDisplayedMonth);
                                    }}
                                    allDaySlot={false}
                                    displayEventTime={false}
                                    eventInteractive={false}
                                    eventClick={(info) => {
                                        info.jsEvent.preventDefault();
                                    }}
                                    eventDisplay="block"
                                    eventBackgroundColor="transparent"   // ✅ Remove default background
                                    eventBorderColor="transparent"
                                    eventContent={(eventInfo) => {
                                        const eventType = eventInfo.event.extendedProps.type;

                                        const bgColor =
                                            eventType === "working"
                                                ? "#556ee6"  // blue
                                                : "#fdd48f"; // yellow

                                        const textColor =
                                            eventType === "working"
                                                ? "#ffffff"
                                                : "#000000";

                                        return {
                                            html: `
                                                <div style="
                                                    background:${bgColor};
                                                    color:${textColor};
                                                    padding:2px 4px; 
                                                    font-size:12px;
                                                ">
                                                ${eventInfo.event.title}
                                                </div>`
                                        };
                                    }}
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        </div >
    )
}
AttendanceMonthlyReport.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default AttendanceMonthlyReport
